import {setLicenseKey} from "survey-core";
export default defineNuxtPlugin(() => {
    setLicenseKey(
        "MTU3ZDcyNTMtY2Y4NS00YTQ4LWJiZWEtZTgwZTkzNTA1MGRmOzE9MjAyNS0xMC0xMCwyPTIwMjUtMTAtMTAsND0yMDI1LTEwLTEw"
    );
});